import { MsdNumberOfDoResearchStyled } from "./styled";
import { Blocks, Icons } from "components";
import { RenderCommaMoney } from "utils/functions/FormatMoney";

const MsdNumberOfDoResearch = ({ data }) => {
  return (
    <MsdNumberOfDoResearchStyled>
      <Blocks.Box
        theme_standard_box
        paddingTop="12px"
        paddingRight="12px"
        paddingBottom="0px"
        paddingLeft="16px"
        // height="160px"
      >
        <div className="top_current">
          <Blocks.BoxLabelCenter
            theme_standard_box_4_col
            label1="จำนวนพนักงานที่ทำแบบทดสอบ "
            label2="The Number of employees to do the research"
            iconShow={<Icons.Build width="32" height="40" />}
            label3Fontsize="56px"
            label3FontsColor="#2A74A3"
            labelBackFontsize="26px"
            label3={
              data && data.msd_user_count_total > 0
                ? `${RenderCommaMoney(data.msd_user_count_total, true)}`
                : "0"
            }
            labelBack="คน"
          />
        </div>
      </Blocks.Box>
    </MsdNumberOfDoResearchStyled>
  );
};

export default MsdNumberOfDoResearch;
